var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('div',{staticClass:"bg-login"},[_c('img',{staticClass:"logo-black",attrs:{"src":require("@/core/assets/img/marketea_logo_2023_blue.svg"),"alt":"logo"},on:{"click":_vm.backWebsite}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }